import http from "../request/http.js"
import base from "../request/base.js"
import axios from "axios"

/****************************************************************登录权限接口***************************************************************/

/**
 * 登录权限接口-验证码
 */
export const loginCaptcha = function() {
	return http({
		url: `${base.url}/Login/captcha`
	})
}

export const loginConfig = function(data) {
	return http({
		url: `${base.url}/Login/getSystem`,
        data,
        method: 'post'
	})
}

/**
 * 登录权限接口-自动登录
 * @param {Object} data {username:用户名 password:密码 captcha:验证码}
 */
export const autoLoginByAccount = function(data) {
	return http({
		url: `${base.url}/login/autoLoginByAccount`,
		data,
		method: 'post'
	})
}

/**
 * 登录权限接口-跳转
 * @param {Object} data {username:用户名 password:密码 captcha:验证码}
 */
export const getSSOUrl = function(data) {
	return http({
		url: `${base.url}/admin/getTicket`,
		data,
		method: 'post'
	})
}

/**
 * 登录权限接口-登录
 * @param {Object} data {username:用户名 password:密码 captcha:验证码}
 */
export const adminLogin = function(data) {
	return http({
		url: `${base.url}/login/adminLogin`,
		data,
		method: 'post'
	})
}

export const sms = function(data) {
	return http({
		url: `${base.url}/login/sms`,
		data,
		method: 'post'
	})
}

export const forgetLogin = function(data) {
	return http({
		url: `${base.url}/login/forget`,
		data,
		method: 'post'
	})
}

/**
 * 登录权限接口-当前管理员的菜单权限和节点权限
 */
export const adminMenu = function(data) {
	return http({
		url: `${base.url}/admin/menu`,
		method: 'post'
	})
}

/**
 * 登录权限接口-角色列表
 * @param {Object} data {page:页数 limit:每页条数}
 */
export const roleLists = function(data) {
	return http({
		url: `${base.url}/role/lists`,
		data,
		method: 'post'
	})
}

/**
 * 登录权限接口-角色详情
 * @param {Object} data {group_id:角色id}
 */
export const roleDetail = function(data) {
	return http({
		url: `${base.url}/role/detail`,
		data,
		method: 'post'
	})
}

/**
 * 登录权限接口-角色新增
 * @param {Object} data {group_name:角色名称 rules:权限数组}
 */
export const roleAdd = function(data) {
	return http({
		url: `${base.url}/role/add`,
		data,
		method: 'post'
	})
}

/**
 * 登录权限接口-角色编辑
 * @param {Object} data {group_id:角色id group_name:角色名称 rules:权限数组}
 */
export const roleEdit = function(data) {
	return http({
		url: `${base.url}/role/edit`,
		data,
		method: 'post'
	})
}

/**
 * 登录权限接口-角色删除
 * @param {Object} data {group_id:角色id}
 */
export const roleDel = function(data) {
	return http({
		url: `${base.url}/role/del`,
		data,
		method: 'post'
	})
}

/**
 * 登录权限接口-组织架构列表
 * @param {Object} data {page:页数 limit:每页条数}
 */
export const adminLists = function(data) {
	return http({
		url: `${base.url}/admin/lists`,
		data,
		method: 'post'
	})
}

/**
 * 登录权限接口-组织架构详情
 * @param {Object} data {admin_id: 账号列表id}
 */
export const adminDetail = function(data) {
	return http({
		url: `${base.url}/admin/detail`,
		data,
		method: 'post'
	})
}

/**
 * 登录权限接口-组织架构新增
 * @param {Object} data {nick_name:昵称 phone:账号 group_id:角色id admin_pid:上级id}
 */
export const adminAdd = function(data) {
	return http({
		url: `${base.url}/admin/add`,
		data,
		method: 'post'
	})
}

/**
 * 登录权限接口-组织架构编辑
 * @param {Object} data {nick_name:昵称 phone:账号 group_id:角色id admin_pid:上级id admin_id:管理员id}
 */
export const adminEdit = function(data) {
	return http({
		url: `${base.url}/admin/edit`,
		data,
		method: 'post'
	})
}

/**
 * 登录权限接口-组织架构禁用启用
 * @param {Object} data {admin_id:管理员id}
 */
 export const adminDisable = function(data) {
	return http({
		url: `${base.url}/admin/disable`,
		data,
		method: 'post'
	})
}

/**
 * 登录权限接口-组织架构删除
 * @param {Object} data {admin_id:管理员id}
 */
export const adminDel = function(data) {
	return http({
		url: `${base.url}/admin/del`,
		data,
		method: 'post'
	})
}

/**
 * 修改登录密码
 * @param {Object} data {old_password:旧密码 new_password:新密码}
 */
export const adminChangePassword = function(data) {
	return http({
		url: `${base.url}/admin/changePassword`,
		data,
		method: 'post'
	})
}

/**
 * 修改登录密码
 * @param {Object} data {admin_id:管理员id}
 */
export const adminSetDefaultPassword = function(data) {
	return http({
		url: `${base.url}/admin/setDefaultPassword`,
		data,
		method: 'post'
	})
}

/**
 * 修改登录密码
 * @param {Object} data {admin_id:管理员id}
 */
export const adminResetLogin = function(data) {
	return http({
		url: `${base.url}/admin/resetLogin`,
		data,
		method: 'post'
	})
}

/**
 * 操作日志
 * @param {Object} data {created_time:时间范围}
 */
export const indexLogs = function(data) {
	return http({
		url: `${base.url}/index/logs`,
		data,
		method: 'post'
	})
}

/**
 * 登录权限接口-供应链配置
 */
export const settingSupply = function(data, method = 'get') {
	return http({
		url: `${base.url}/setting/supply`,
		data,
		method
	})
}

/**
 * 登录权限接口-公司信息编辑
 */
export const firmInfoEdit = function(data) {
	return http({
		url: `${base.url}/setting/baseinfo`,
		data,
		method: 'post'
	})
}

/**
 * 登录权限接口-公司信息详情
 */
export const firmInfoDeatail = function() {
	return http({
		url: `${base.url}/setting/baseinfo`
	})
}

// 系统设置
export const systemset = function(method, data) {
	return http({
		url: `${base.url}/setting/system`,
        data,
		method
	})
}

/**
 * 登录权限接口-首页接口
 */
export const index = function() {
	return http({
		url: `${base.url}/index/index`,
		method: 'post'
	})
}

/**
 * 登录权限接口-权限列表
 */
export const roleRules = function() {
	return http({
		url: `${base.url}/role/rules`,
		method: 'post'
	})
}

/**
 * 任务列表
 */
export const tasks = function(data) {
	return http({
		url: `${base.url}/index/tasks`,
		method: 'post',
        data
	})
}

/**
 * 任务取消
 */
export const taskCancel = function(data) {
	return http({
		url: `${base.url}/index/taskCancel`,
		method: 'post',
        data
	})
}

/****************************************************************客户档案***************************************************************/

/**
 * 客户档案-列表
 * @param {Object} data {consumer_name:客户名称 admin_id:业务专员 created_time:时间范围 
 * consumer_star:客户星级 audit:账户状态 page:页数 limit:条数}
 */
export const consumerLists = function(data) {
	return http({
		url: `${base.url}/consumer/lists`,
		data,
		method: 'post'
	})
}

/**
 * 客户档案-新增
 * @param {Object} data {consumer_name:客户名称 admin_id:业务专员 created_time:时间范围 
 * consumer_star:客户星级 audit:账户状态 page:页数 limit:条数}
 */
export const consumerAdd = function(data) {
	return http({
		url: `${base.url}/consumer/add`,
		data,
		method: 'post'
	})
}

/**
 * 客户档案-编辑
 * @param {Object} data {consumer_id:客户id consumer_name:客户名称 admin_id:业务专员 created_time:时间范围 
 * consumer_star:客户星级 audit:账户状态 page:页数 limit:条数}
 */
export const consumerEdit = function(data) {
	return http({
		url: `${base.url}/consumer/edit`,
		data,
		method: 'post'
	})
}

/**
 * 客户档案-详情
 * @param {Object} data {consumer_id:客户id}
 */
export const consumerDetail = function(data) {
	return http({
		url: `${base.url}/consumer/detail`,
		data,
		method: 'post'
	})
}

/**
 * 客户跟进录入
 * @param {Object} data {visit_time:拜访时间 consumer_id:客户id visit_object:拜访对象 visit_duty:职务
 * admin_id:拜访人id entourage_id:陪同人员id visit_method:拜访方式 1=上门拜访,2=电话拜访 visit_content:拜访内容 
 * visit_feedback:回馈 visit_imgs:拍照}
 */
export const consumerVisit = function(data) {
	return http({
		url: `${base.url}/consumer/visit`,
		data,
		method: 'post'
	})
}

/**
 * 客户档案-删除
 * @param {Object} data {consumer_id:客户id}
 */
export const consumerDel = function(data) {
	return http({
		url: `${base.url}/consumer/del`,
		data,
		method: 'post'
	})
}

/****************************************************************供应商***************************************************************/

/**
 * 供应商-列表
 * @param {Object} data {page:页数 limit:条数}
 */
export const supplierLists = function(data) {
	return http({
		url: `${base.url}/supplier/lists`,
		data,
		method: 'post'
	})
}

/**
 * 供应商-列表
 * @param {Object} data {page:页数 limit:条数}
 */
export const supplierSelect = function(data) {
	return http({
		url: `${base.url}/supplier/select`,
		data,
		method: 'post'
	})
}

/**
 * 供应商-新增
 * @param {Object} data {supplier_name:简称 supplier_company:公司 supplier_logo:logo supplier_licenses:执照证件 supplier_header:负责人
 * supplier_phone:负责人电话 supplier_collection:收款信息 supplier_expire:有效期 supplier_cates:类目 supplier_remark:备注 supplier_account:登录账号}
 */
export const supplierAdd = function(data) {
	return http({
		url: `${base.url}/supplier/add`,
		data,
		method: 'post'
	})
}

/**
 * 供应商-编辑
 * @param {Object} data {supplier_id:供应商id supplier_name:简称 supplier_company:公司 supplier_logo:logo supplier_licenses:执照证件 supplier_header:负责人
 * supplier_phone:负责人电话 supplier_collection:收款信息 supplier_expire:有效期 supplier_cates:类目 supplier_remark:备注}
 */
export const supplierEdit = function(data) {
	return http({
		url: `${base.url}/supplier/edit`,
		data,
		method: 'post'
	})
}

/**
 * 供应商-删除
 * @param {Object} data {supplier_id:供应商id }
 */
export const supplierDel = function(data) {
	return http({
		url: `${base.url}/supplier/del`,
		data,
		method: 'post'
	})
}

/**
 * 供应商-详情
 * @param {Object} data {supplier_id:供应商id }
 */
export const supplierDetail = function(data) {
	return http({
		url: `${base.url}/supplier/detail`,
		data,
		method: 'post'
	})
}

/**
 * 供应商(结算列表、结算详情)
 * @param {Object} data {}
 * 结算列表:data {created_time:时间范围 supplier_id:供应商id，登录信息中的supplier_id settlement_no:结算单号 state:状态1=待结算,2=已结算,3=已结算已到款}
 * 结算详情:data {settlement_id}
 * @param {Number} type {0:结算列表 1:结算详情}
 */
var supplierTypeList = ['settlementLists', 'settlementDetail', 'sale', 'saleLists', 'settlementAdd', 'settlementEdit','settlementPay','settlementReceived']
export const supplier = function(data, type) {
	return http({
		url: `${base.url}/supplier/${supplierTypeList[type]}`,
		data,
		method: 'post'
	})
}

/****************************************************************商品***************************************************************/

/**
 * 同步供应链商品
 */
export const goodAsyncSupply = function(data) {
	return http({
		url: `${base.url}/good/asyncSupply`
	})
}

/**
 * 商品分类列表
 * @param {Object} data {cate_type:1=商品分类,3=品牌分类}
 */
export const goodsCateLists = function(data) {
	return http({
		url: `${base.url}/goodsCate/lists`,
		data,
		method: 'post'
	})
}

/**
 * 商品分类新增
 * @param {Object} data {cate_type:1=商品分类,3=品牌分类 cate_pid:分类id cate_name:分类名称 cate_icon:分类图标 sort:排序 tags:标签}
 */
export const goodsCateAdd = function(data) {
	return http({
		url: `${base.url}/goodsCate/add`,
		data,
		method: 'post'
	})
}

/**
 * 商品列表
 * @param {Object} data {good_id:商品id good_name:商品名称 brcode: cate_id: brand_id: state: good_source: tag_id: sort:}
 */
export const goodLists = function(data) {
	return http({
		url: `${base.url}/good/lists`,
		data,
		method: 'post'
	})
}

/**
 * 分类上下架
 * @param {Object} data {cate_id:}
 */
export const goodsCateDetail = function(data) {
	return http({
		url: `${base.url}/goodsCate/detail`,
		data,
		method: 'post'
	})
}

/**
 * 商品分类编辑
 * @param {Object} data {cate_type:1=商品分类,3=品牌分类 cate_pid: cate_name: cate_icon: sort: tags: cate_id: }
 */
export const goodsCateEdit = function(data) {
	return http({
		url: `${base.url}/goodsCate/edit`,
		data,
		method: 'post'
	})
}

/**
 * 分类上下架
 * @param {Object} data {cate_id:}
 */
export const goodsCateDisable = function(data) {
	return http({
		url: `${base.url}/goodsCate/disable`,
		data,
		method: 'post'
	})
}

/**
 * 分类删除
 * @param {Object} data {cate_id:}
 */
export const goodsCateDel = function(data) {
	return http({
		url: `${base.url}/goodsCate/del`,
		data,
		method: 'post'
	})
}

/**
 * 商品添加
 * @param {Object} data {good_name: good_alias: good_desc: good_source:商品来源:1=平台商品,2=商家商品,3=供应链,4=供应商 good_type:商品性质,1=标准商品,2=虚拟商品,3=技能服务
 * good_brand:[[一级分裂,二级分类],[一级分裂,二级分类]] good_cate:[[一级分裂,二级分类],[一级分裂,二级分类]] tag_ids:标签 promise:销售承诺 cover_img:主图 wheel_img:轮播图
 * detail_img:详情图 content:详情 video_type:视频类型:1=本地,2=外链 video_url:视频url video_buyed:购买后才能看视频,0=默认可看 buy_min:最低购买量 buy_max:最大限购量
 * spec_name1: spec_name2: skus:unit_quatity单位数量,cost_price成本价,sale_price销售价,crossed_price划线价,brcode条形码,stock库存}
 */
export const goodAdd = function(data) {
	return http({
		url: `${base.url}/good/add`,
		data,
		method: 'post'
	})
}

/**
 * 商品编辑
 * @param {Object} data {good_name: good_alias: good_desc: good_source:商品来源:1=平台商品,2=商家商品,3=供应链,4=供应商 good_type:商品性质,1=标准商品,2=虚拟商品,3=技能服务
 * good_brand:[[一级分裂,二级分类],[一级分裂,二级分类]] good_cate:[[一级分裂,二级分类],[一级分裂,二级分类]] tag_ids:标签 promise:销售承诺 cover_img:主图 wheel_img:轮播图
 * content:详情 video_type:视频类型:1=本地,2=外链 video_url:视频url video_buyed:购买后才能看视频,0=默认可看 buy_min:最低购买量 buy_max:最大限购量 spec_name1: 
 * spec_name2: skus:unit_quatity单位数量, good_id:}
 */
export const goodEdit = function(data) {
	return http({
		url: `${base.url}/good/edit`,
		data,
		method: 'post'
	})
}

/**
 * 商品详情
 * @param {Object} data {good_id:商品id}
 */
export const goodDetail = function(data) {
	return http({
		url: `${base.url}/good/detail`,
		data,
		method: 'post'
	})
}

/**
 * 商品批量上下架
 * @param {Object} data {ids: 商品id数组 state:1=上架，2=下架}
 */
export const goodState = function(data) {
	return http({
		url: `${base.url}/good/state`,
		data,
		method: 'post'
	})
}

/**
 * 商品批量删除
 * @param {Object} data {ids: 商品id数组}
 */
export const goodDel = function(data) {
	return http({
		url: `${base.url}/good/del`,
		data,
		method: 'post'
	})
}

/**
 * 商品设置排序
 * @param {Object} data {ids: good_id:}
 */
export const goodSort = function(data) {
	return http({
		url: `${base.url}/good/sort`,
		data,
		method: 'post'
	})
}

/**
 * 商品调价格
 * @param {Object} data {sku_id: field:cost_price 或 sale_price 或 crossed_price level_id:1-5 value:价格}
 */
export const goodChangePrice = function(data) {
	return http({
		url: `${base.url}/good/changePrice`,
		data,
		method: 'post'
	})
}

/**
 * 商品调利润
 * @param {Object} data {sku_ids: data:field价格字段，level_id等级字段,checked是否勾选,type1=指定，2=上调，3=下调,value值}
 */
export const goodChangeProfit = function(data) {
	return http({
		url: `${base.url}/good/changeProfit`,
		data,
		method: 'post'
	})
}

/**
 * 商品调库存
 * @param {Object} data {sku_ids: type:1=指定为,2=上调，3=下调 value:价格}
 */
export const goodChangeStock = function(data) {
	return http({
		url: `${base.url}/good/changeStock`,
		data,
		method: 'post'
	})
}

/****************************************************************商品出入库***************************************************************/
export const inventoryLists = function(data) {
	return http({ url: `${base.url}/inventory/lists`, data, method: 'post' })
}

export const inventoryLogs = function(data) {
	return http({ url: `${base.url}/inventory/logs`, data, method: 'post' })
}

export const inventoryAdd = function(data) {
	return http({ url: `${base.url}/inventory/add`, data, method: 'post' })
}

export const inventoryEdit = function(data) {
	return http({ url: `${base.url}/inventory/edit`, data, method: 'post' })
}

export const inventoryDel = function(data) {
	return http({ url: `${base.url}/inventory/del`, data, method: 'post' })
}

export const inventoryCount = function(data) {
	return http({ url: `${base.url}/inventory/count`, data, method: 'post' })
}

/****************************************************************册集***************************************************************/

/**
 * 册集列表
 */
export const catalogueLists = function() {
	return http({
		url: `${base.url}/catalogue/lists`,
		method: 'post'
	})
}

/**
 * 册集选项
 */
export const catalogueOptions = function(data) {
	return http({
		url: `${base.url}/catalogue/options`,
		data,
		method: 'post'
	})
}

/**
 * 册集新增
 * @param {Object} data {catalogue_name:册集名称 catalogue_goods:关联商品 catalogue_coverimg:封面图 catalogue_backimg:封底图
 * catalogue_logo:封面logo catalogue_background:内页底图 catalogue_title:封面标题 catalogue_company:公司名称 expire_start:有效期开始
 * expire_end:有效期截止 catalogue_style:排版1页N品 catalogue_about_log:封底落款logo catalogue_about_company:封底落款公司
 * catalogue_about_en:封底落款公司英文 catalogue_about_address:封底落款地址 catalogue_about_phone:封底落款电话}
 */
export const catalogueAdd = function(data) {
	return http({
		url: `${base.url}/catalogue/add`,
		data,
		method: 'post'
	})
}

/**
 * 册集编辑
 * @param {Object} data {catalogue_id: catalogue_name:册集名称 catalogue_goods:关联商品 catalogue_coverimg:封面图 catalogue_backimg:封底图
 * catalogue_logo:封面logo catalogue_background:内页底图 catalogue_title:封面标题 catalogue_company:公司名称 expire_start:有效期开始
 * expire_end:有效期截止 catalogue_style:排版1页N品 catalogue_about_log:封底落款logo catalogue_about_company:封底落款公司
 * catalogue_about_en:封底落款公司英文 catalogue_about_address:封底落款地址 catalogue_about_phone:封底落款电话}
 */
export const catalogueEdit = function(data) {
	return http({
		url: data.catalogue_id ? `${base.url}/catalogue/edit` : `${base.url}/catalogue/add`,
		data,
		method: 'post'
	})
}

/**
 * 册集导出ppt
 * @param {Object} data {catalogue_id:}
 */
export const cataloguePpt = function(data) {
	return http({
		url: `${base.url}/catalogue/ppt`,
		data,
		method: 'post'
	})
}

/**
 * 册集详情
 * @param {Object} data {catalogue_id:}
 */
export const catalogueDetail = function(data) {
	return http({
		url: `${base.url}/catalogue/detail`,
		data,
		method: 'post'
	})
}

/**
 * 册集详情
 * @param {Object} data {catalogue_id:}
 */
export const catalogueDel = function(data) {
	return http({
		url: `${base.url}/catalogue/del`,
		data,
		method: 'post'
	})
}

/****************************************************************卡券制作***************************************************************/

/**
 * 礼卡券列表
 * @param {Object} data {state:状态:1=正常,2=禁用,3=已删除 card_name:卡名称 card_type:卡券类型:1=储值卡,2=兑换卡,3=满减卡}
 */
export const cardCardLists = function(data) {
	return http({
		url: `${base.url}/card/cardLists`,
		data,
		method: 'post'
	})
}

/**
 * 实体卡制作列表
 */
export const cardLists = function() {
	return http({
		url: `${base.url}/card/lists`,
		method: 'post'
	})
}

/**
 * 实体卡制作选项
 * @param {Object} data {card_id:卡id apply_quatity:数量 apply_material:材质:1=PVC卡(90-45mm),2=纸质(90-45mm 200克纸厚),3=纸质(180-45mm 200克纸厚)
 * apply_coverimg:封面图 apply_backimg:背景图 apply_logo:logo receive_name:收货人 receive_phone:收货电话 receive_address:收货地址}
 */
 export const cardOptions = function(data) {
	return http({
		url: `${base.url}/card/options`,
		data,
		method: 'post'
	})
}

/**
 * 实体卡制作添加
 * @param {Object} data {card_id:卡id apply_quatity:数量 apply_material:材质:1=PVC卡(90-45mm),2=纸质(90-45mm 200克纸厚),3=纸质(180-45mm 200克纸厚)
 * apply_coverimg:封面图 apply_backimg:背景图 apply_logo:logo receive_name:收货人 receive_phone:收货电话 receive_address:收货地址}
 */
export const cardAdd = function(data) {
	return http({
		url: `${base.url}/card/add`,
		data,
		method: 'post'
	})
}

/**
 * 实体卡制作编辑
 * @param {Object} data {apply_id: card_id:卡id apply_quatity:数量 apply_material:材质:1=PVC卡(90-45mm),2=纸质(90-45mm 200克纸厚),3=纸质(180-45mm 200克纸厚)
 * apply_coverimg:封面图 apply_backimg:背景图 apply_logo:logo receive_name:收货人 receive_phone:收货电话 receive_address:收货地址}
 */
export const cardEdit = function(data) {
	return http({
		url: data.apply_id ? `${base.url}/card/edit` : `${base.url}/card/add`,
		data,
		method: 'post'
	})
}

/**
 * 实体卡制作详情
 * @param {Object} data {apply_id:}
 */
export const cardDetail = function(data) {
	return http({
		url: `${base.url}/card/detail`,
		data,
		method: 'post'
	})
}

/**
 * 实体卡制作删除
 * @param {Object} data {apply_id:}
 */
export const cardDel = function(data) {
	return http({
		url: `${base.url}/card/del`,
		data,
		method: 'post'
	})
}

/****************************************************************采集业务单据***************************************************************/

/**
 * 采集业务单据列表
 * @param {Object} data {consumer_id:客户id created_by:创建人id audit:审核状态}
 * @param {Number} type {0:业务商机列表 1:备货/询价列表 2.客户报价列表 3.客户合同列表 4.商品采购列表 5.商品出库列表}
 */
var typeList = ['opportunityLists', 'stockupLists', 'quotationLists', 'contractLists', 'procureLists', 'outboundLists']
export const procurementLists = function(data, type) {
	return http({
		url: `${base.url}/procurement/${typeList[type]}`,
		data,
		method: 'post'
	})
}

/**
 * 采集业务单据新增
 * @param {Object} data {procurement_name:简要名称 consumer_id:客户id opportunity_id:商机id quotation_id:报价单id 
 * contract_id:合同id procurement_info:项目概述 procurement_start:开始时间 procurement_end:截止时间 procurement_files:附件资料
 * procurement_receive:收货信息 procurement_tax:发票税率 procurement_amount:业务总额 procurement_settlement:结算方式
 * procurement_goods:货物明细}
 * @param {Number} type {0:业务商机新增 1:备货/询价新增 2.客户报价新增 3.客户合同新增 4.商品采购新增 5.商品出库新增}
 */
var addTypeList = ['opportunityAdd', 'stockupAdd', 'quotationAdd', 'contractAdd', 'procureAdd', 'outboundAdd']
export const procurementAdd = function(data, type) {
	return http({
		url: `${base.url}/procurement/${addTypeList[type]}`,
		data,
		method: 'post'
	})
}

/**
 * 采集业务单据编辑
 * @param {Object} data {procurement_id: 单据id procurement_name:简要名称 consumer_id:客户id opportunity_id:商机id quotation_id:报价单id 
 * contract_id:合同id procurement_info:项目概述 procurement_start:开始时间 procurement_end:截止时间 procurement_files:附件资料
 * procurement_receive:收货信息 procurement_tax:发票税率 procurement_amount:业务总额 procurement_settlement:结算方式
 * procurement_goods:货物明细}
 * @param {Number} type {0:业务商机编辑 1:备货/询价编辑 2.客户报价编辑 3.客户合同编辑 4.商品采购编辑 5.商品出库编辑}
 */
var editTypeList = ['opportunityEdit', 'stockupEdit', 'quotationEdit', 'contractEdit', 'procureEdit', 'outboundEdit']
export const procurementEdit = function(data, type) {
	return http({
		url: `${base.url}/procurement/${editTypeList[type]}`,
		data,
		method: 'post'
	})
}

/**
 * 采集业务单据详情
 * @param {Object} data {procurement_id: 单据id}
 * @param {Number} type {0:业务商机详情 1:备货/询价详情 2.客户报价详情 3.客户合同详情 4.商品采购详情 5.商品出库详情}
 */
var detailTypeList = ['opportunityDetail', 'stockupDetail', 'quotationDetail', 'contractDetail', 'procureDetail',
	'outboundDetail'
]
export const procurementDetail = function(data, type) {
	return http({
		url: `${base.url}/procurement/${detailTypeList[type]}`,
		data,
		method: 'post'
	})
}

/**
 * 采集业务单据删除或者失效
 * @param {Object} data {procurement_id: }
 * @param {Number} type {0:业务商机失效 1:备货/询价删除 2:客户报价删除 3:客户合同失效 4:商品采购删除 5:商品出库删除}
 */
var delTypeList = ['opportunityDisable', 'stockupDel', 'quotationDel', 'contractDisable', 'procureDel', 'outboundDel']
export const procurementDel = function(data, type) {
	return http({
		url: `${base.url}/procurement/${delTypeList[type]}`,
		data,
		method: 'post'
	})
}

/**
 * 合同完结
 * @param {Object} data {procurement_id:}
 */
export const procurementContractComplete = function(data) {
	return http({
		url: `${base.url}/procurement/contractComplete`,
		data,
		method: 'post'
	})
}

/****************************************************************财务***************************************************************/


/**
 * 收支分类(新增、删除、编辑、详情、列表)
 * @param {Object} data {}
 * 新增:data {cate_type:分类类型;1=收入,2=支出 cate_name:分类名称 cate_pid:上级分类 cate_remark:备注 cate_sort:排序}
 * 删除:data {cate_id: }
 * 编辑:data {cate_id: cate_type:分类类型;1=收入,2=支出 cate_name:分类名称 cate_pid:上级分类 cate_remark:备注 cate_sort:排序}
 * 详情:data {cate_id: }
 * 列表:data {cate_type:分类类型;1=收入,2=支出}
 * @param {Number} type {0:新增 1:删除 2:编辑 3:详情 4:列表}
 */
var billCateTypeList = ['add', 'del', 'edit', 'detail', 'lists']
export const billCate = function(data, type) {
	return http({
		url: `${base.url}/billCate/${billCateTypeList[type]}`,
		data,
		method: 'post'
	})
}


/**
 * 收付款(新增、删除、编辑、详情、列表、选项、统计)
 * @param {Object} data {
 * 新增:data {bill_type:类型:1=收款单,2=付款单 bill_time:时间 bill_object:单位,对方名称 
 * bill_paytype:支付方式:1=银行转账,2=现金,3=微信,4=支付宝,5=其他 bill_amount:金额 remark:事由 cate_id1:分类1
 * cate_id2:分类2 consumer_id:客户id contract_id:合同id}
 * 删除:data {bill_id:}
 * 编辑:data {bill_id: bill_type:类型:1=收款单,2=付款单 bill_time:时间 bill_object:单位,对方名称 
 * bill_paytype:支付方式:1=银行转账,2=现金,3=微信,4=支付宝,5=其他 bill_amount:金额 remark:事由 cate_id1:分类1
 * cate_id2:分类2 consumer_id:客户id contract_id:合同id}
 * 详情:data {bill_id:}
 * 列表:data {bill_type:类型:1=收款单,2=付款单 cate_id1:一级类目id created_time:创建时间范围 audit:审核状态
 * consumer_id:客户id created_by:创建人id}
 * 选项:
 * 统计:data {start_date:开始时间 end_date:结束时间}
 * @param {Number} type {0:新增 1:删除 2:编辑 3:详情 4:列表 5:选项 6:统计}
 */
var billTypeList = ['add', 'del', 'edit', 'detail', 'lists', 'options', 'statistics']
export const bill = function(data, type) {
	return http({
		url: `${base.url}/bill/${billTypeList[type]}`,
		data,
		method: 'post'
	})
}


/**
 * 发票(新增、删除、编辑、详情、列表、进度)
 * @param {Object} data {}
 * 新增:data {invoice_time:时间 consumer_id:客户id company_name:公司名称 company_tax_no:公司税号 invoice_amount:金额
 * invoice_type:类型:1=普通发票,2=专用发票 invoice_need:开票要求json,附商品清单goods invoice_start:开始时间要求 
 * invoice_end:截止时间要求 contract_id:合同id invoice_remark:备注}
 * 删除:data {invoice_id:发票id}
 * 编辑:data {invoice_id:发票id invoice_time:时间 consumer_id:客户id company_name:公司名称 company_tax_no:公司税号 invoice_amount:金额
 * invoice_type:类型:1=普通发票,2=专用发票 invoice_need:开票要求json,附商品清单goods invoice_start:开始时间要求 
 * invoice_end:截止时间要求 contract_id:合同id invoice_remark:备注}
 * 详情:data {invoice_id:}
 * 列表:data {created_time:创建时间范围 invoice_progress:开票进度 audit:审核状态 consumer_id:客户id created_by:创建人id}
 * 进度:data {invoice_id:发票id invoice_amount_money:开票金额 invoice_no:发票编号}
 * @param {Number} type {0:新增 1:删除 2:编辑 3:详情 4:列表 5:进度}
 */
var invoiceTypeList = ['add', 'del', 'edit', 'detail', 'lists', 'done']
export const invoice = function(data, type) {
	return http({
		url: `${base.url}/invoice/${invoiceTypeList[type]}`,
		data,
		method: 'post'
	})
}

/**
 * 提成(新增、删除、编辑、详情、方案列表、明细列表、选项)
 * @param {Object} data {}
 * 新增:data {commission_name:名称 commission_trigger:触发 commission_role:角色 start_time:开始时间
 * end_time:结束时间 commission_plans:提成方案}
 * 删除:data {commission_id:}
 * 编辑:data {commission_id: commission_name:名称 commission_trigger:触发 commission_role:角色 start_time:开始时间
 * end_time:结束时间 commission_plans:提成方案}
 * 详情:data {commission_id:}
 * 方案列表:
 * 明细列表:data {created_time:创建时间范围 admin_id:人员id commission_id:提成方案id procurement_id:合同id}
 * 选项:
 * @param {Number} type {0:新增 1:删除 2:编辑 3:详情 4:方案列表 5:明细列表 6:选项}
 */
var commissionTypeList = ['add', 'del', 'edit', 'detail', 'lists', 'logs', 'options']
export const commission = function(data, type) {
	return http({
		url: `${base.url}/commission/${commissionTypeList[type]}`,
		data,
		method: 'post'
	})
}

/**
 * 业务统计本月经营和经营曲线
 * @param {*} data 
 * @param {*} type 
 * @returns 
 */
export const indexStatistics = function(data, type) {
	return http({
		url: `${base.url}/index/statistics`,
		data,
		method: 'post'
	})
}

/**
 * 业务统计合同列表
 * @param {*} data 
 * @param {*} type 
 * @returns 
 */
export const procurementContractList = function(data, type) {
	return http({
		url: `${base.url}/procurement/contractList`,
		data,
		method: 'post'
	})
}

/****************************************************************协同(OA)***************************************************************/

/**
 * 审批模板(新增、删除、编辑、详情、列表、启用/禁用、关联业务表单选项)
 * @param {Object} data {}
 * 新增:data {template_name:模板名称 template_sort:排序 template_type:适用表单 template_relate:关联业务表单 template_form:自定义表单}
 * 删除:data {template_id:模板id}
 * 编辑:data {template_id:模板id template_name:模板名称 template_sort:排序 template_type:适用表单 template_relate:关联业务表单 template_form:自定义表单}
 * 详情:data {template_id:模板id}
 * 列表:data {state:状态 template_type:适用表单:1=关联业务表单,2=自定义表单}
 * 启用/禁用:data {template_id:模板id}
 * 关联:
 * @param {Number} type {0:新增 1:删除 2:编辑 3:详情 4:列表 5:启用/禁用 6:关联}
 */
var oaTemplateTypeList = ['templateAdd', 'templateDel', 'templateEdit', 'templateDetail', 'templateLists',
	'templateDisable', 'templateOptions'
]
export const oaTemplate = function(data, type) {
	return http({
		url: `${base.url}/oa/${oaTemplateTypeList[type]}`,
		data,
		method: 'post'
	})
}

/**
 * 审批流程(详情、编辑)
 * @param {Object} data {}
 * 详情:data {template_id:模板id}
 * 编辑:data {template_id:模板id nodes:节点设置，node_name节点名称，node_admin_id审批人}
 * @param {Number} type {0:详情 1:编辑}
 */
var oaFlowTypeList = ['flowDetail', 'flowEdit']
export const oaFlow = function(data, type) {
	return http({
		url: `${base.url}/oa/${oaFlowTypeList[type]}`,
		data,
		method: 'post'
	})
}

export const flowDetail = function(data) {
	return http({
		url: `${base.url}/oa/flowDetail`,
		data,
		method: 'post'
	})
}

export const flowEdit = function(data) {
	return http({
		url: `${base.url}/oa/flowEdit`,
		data,
		method: 'post'
	})
}

/**
 * 提审(自定义表单、关联业务、列表、详情、编辑自定义表单)
 * @param {Object} data {}
 * 自定义表单:data {template_id:模板id template_form:自定义表单内容}
 * 关联业务:data {template_id:模板id}
 * 列表:data {template_id:模板id}
 * 详情:data {apply_id:模板id}
 * 编辑自定义表单:data {template_id:模板id template_form:自定义表单内容}
 * @param {Number} type {0:自定义表单 1:关联业务 2:列表 3:详情 4:编辑自定义表单}
 */
var oaApplyTypeList = ['applyFrom', 'apply', 'applyLists', 'applyDetail', 'applyFromEdit', 'applyDel']
export const oaApply = function(data, type) {
	return http({
		url: `${base.url}/oa/${oaApplyTypeList[type]}`,
		data,
		method: 'post'
	})
}

/**
 * 审批(审批别人的申请、撤回:申请)
 * @param {Object} data {}
 * 审批:data {apply_id:申请id audit:2=审核通过,3=审核拒绝 remark:备注}
 * 撤回:data {apply_id:申请id}
 * @param {Number} type {0:审批 1:撤回}
 */
var oaAuditTypeList = ['audit', 'auditCancel']
export const oaAudit = function(data, type) {
	return http({
		url: `${base.url}/oa/${oaAuditTypeList[type]}`,
		data,
		method: 'post'
	})
}

/**
 * 提审(用户申请被拒后的操作)
 * @param {Object} data {}
 * 提审:data {apply_id: 申请id}
 */
var oaReapplyTypeList = ['reapply']
export const oaReapply = function(data, type) {
	return http({
		url: `${base.url}/oa/${oaReapplyTypeList[type]}`,
		data,
		method: 'post'
	})
}




/****************************************************************商城***************************************************************/
/**
 * 商城新增
 * @param {Object} data {shop_name:名称 shop_subject:主体 shop_address:地址 shop_header:负责人 shop_phone:负责人电话 shop_account:账号 shop_password:密码 shop_start: 开始时间 shop_end: 截止时间 shop_remark: 备注 shop_url: 地址}
 */
export const shopAdd = function(data) {
	return http({
		url: `${base.url}/shop/add`,
		data,
		method: 'post'
	})
}

/**
 * 商城列表
 * @param {Object} data {}
 */
export const shopLists = function(data) {
	return http({
		url: `${base.url}/shop/lists`,
		data,
		method: 'post'
	})
}

/**
 * 商城详情
 * @param {Object} data {shop_id: id}
 */
export const shopDetail = function(data) {
	return http({
		url: `${base.url}/shop/detail`,
		data,
		method: 'post'
	})
}

/**
 * 商城编辑
 * @param {Object} data {shop_id:id shop_name:名称 shop_subject:主体 shop_address:地址 shop_header:负责人 shop_phone:负责人电话 shop_account:账号 shop_password:密码 shop_start: 开始时间 shop_end: 截止时间 shop_remark: 备注 shop_url: 地址}
 */
export const shopEdit = function(data) {
	return http({
		url: `${base.url}/shop/edit`,
		data,
		method: 'post'
	})
}

/**
 * 商城停用
 * @param {Object} data {shop_id: id}
 */
export const shopStop = function(data) {
	return http({
		url: `${base.url}/shop/stop`,
		data,
		method: 'post'
	})
}

/**
 * 商城删除
 * @param {Object} data {shop_id: id}
 */
export const shopDel = function(data) {
	return http({
		url: `${base.url}/shop/del`,
		data,
		method: 'post'
	})
}

/**
 * 订单列表
 * @param {Object} data {shop_id: id}
 */
export const orderLists = function(data) {
	return http({
		url: `${base.url}/order/lists`,
		data,
		method: 'post'
	})
}

/**
 * 订单详情
 * @param {Object} data {shop_id: id}
 */
export const orderDetail = function(data) {
	return http({
		url: `${base.url}/order/detail`,
		data,
		method: 'post'
	})
}

/**
 * 订单快递列表
 * @param {Object} data {shop_id: id}
 */
export const orderExpress = function(data) {
	return http({
		url: `${base.url}/order/express`,
		data,
		method: 'post'
	})
}

/**
 * 订单发货
 * @param {Object} data {shop_id: id}
 */
export const orderSend = function(data) {
	return http({
		url: `${base.url}/order/send`,
		data,
		method: 'post'
	})
}

/**
 * 售后列表
 * @param {Object} data {shop_id: id}
 */
export const afterLists = function(data) {
	return http({
		url: `${base.url}/after/lists`,
		data,
		method: 'post'
	})
}

/**
 * 售后详情
 * @param {Object} data {"after_sale_id": 1,
    "handle_type": 1,
    "reject_reason": "handle_type1=退货退款,2=不退货仅退款,为3时填拒绝售后的原因"}
 */
export const afterDetail = function(data) {
	return http({
		url: `${base.url}/after/detail`,
		data,
		method: 'post'
	})
}

/**
 * 售后处理
 * @param {Object} data {"after_sale_id": 1,
    "handle_type": 1,
    "reject_reason": "handle_type1=退货退款,2=不退货仅退款,为3时填拒绝售后的原因"}
 */
export const afterHandle = function(data) {
	return http({
		url: `${base.url}/after/handle`,
		data,
		method: 'post'
	})
}

/**
 * 售后退款
 * @param {Object} data {"after_sale_id": 1,"refund_money": 1}
 */
export const afterRefund = function(data) {
	return http({
		url: `${base.url}/after/refund`,
		data,
		method: 'post'
	})
}
export const articles = function(data) {
	return http({
		url: `${base.url}/system/articles`,
		data,
		method: 'post'
	})
}
/**
 * 账户流水
 */
export const shopBalance = function(data) {
	return http({
		url: `${base.url}/shop/balance`,
		data,
		method: 'post'
	})
}
export const shopBalancelog = function(data) {
	return http({
		url: `${base.url}/shop/balancelog`,
		data,
		method: 'post'
	})
}
export const shopBalancelogexport = function(data) {
	return http({
		url: `${base.url}/shop/balancelogexport`,
		data,
		method: 'post'
	})
}
export const shopSelect = function(data) {
	return http({
		url: `${base.url}/shop/select`,
		data,
		method: 'post'
	})
}
export const shopOperate = function(data) {
	return http({
		url: `${base.url}/shop/operate`,
		data,
		method: 'post'
	})
}
export const shopOperatechart = function(data) {
	return http({
		url: `${base.url}/shop/operatechart`,
		data,
		method: 'post'
	})
}
export const shopOrderbyday = function(data) {
	return http({
		url: `${base.url}/shop/orderbyday`,
		data,
		method: 'post'
	})
}
export const shopCaterank = function(data) {
	return http({
		url: `${base.url}/shop/caterank`,
		data,
		method: 'post'
	})
}
export const shopCatechart = function(data) {
	return http({
		url: `${base.url}/shop/catechart`,
		data,
		method: 'post'
	})
}
export const shopGoodsalerank = function(data) {
	return http({
		url: `${base.url}/shop/goodsalerank`,
		data,
		method: 'post'
	})
}

/**
 * 汇付
 */
export const huifuConfig = function(data, method) {
	return http({
		url: `${base.url}/setting/dougong`,
		data,
		method,
	})
}
export const registerpage = function(data) {
	return http({
		url: `${base.url}/shop/registerpage`,
		data,
		method: 'post'
	})
}

/****************************************************************公共接口***************************************************************/


/**
 * 图片上传
 * @param {Object} formData {选中的图片流}
 */
export const uploadImg = function(formData) {
	var loginInfo = JSON.parse(localStorage.getItem('loginInfo'));
	return new Promise((resolve, reject) => {
		axios({
			url: `${base.url}/index/uploadImg`,
			method: 'post',
			data: formData,
			headers: {
				'Content-Type': 'multipart/form-data',
				'sid': loginInfo ? loginInfo.sid : '',
				'token': loginInfo ? loginInfo.token : '',
				'uid': loginInfo ? loginInfo.admin_id : ''
			}
		}).then((res) => {
			if(res.data.code == 0){
				var imgUrl = `${base.domain}` + res.data.data.url
				resolve(imgUrl);
			}else{
				resolve(-1);
			}
		})
	})
}

/**
 * 视频音频文件上传
 * @param {Object} formData {视频:mp4、avi 音频:mp3}
 */

export const uploadFile = function(formData) {
	var loginInfo = JSON.parse(localStorage.getItem('loginInfo'));
	return new Promise((resolve, reject) => {
		axios({
			url: `${base.url}/index/uploadFile`,
			method: 'post',
			data: formData,
			headers: {
				'Content-Type': 'multipart/form-data',
				'sid': loginInfo ? loginInfo.sid : '',
				'token': loginInfo ? loginInfo.token : '',
				'uid': loginInfo ? loginInfo.admin_id : ''
			}
		}).then((res) => {
			if(res.data.code == 0){
				var fileUrl = `${base.domain}` + res.data.data.url
				resolve(fileUrl);
			}else{
				resolve(-1);
			}
		})
	})
}



export const region = function(data) {
	return http({ url: `${base.url}/system/region`, data, method: 'post' })
}

export const express = function(data) {
	return http({ url: `${base.url}/system/express`, data, method: 'post' })
}

export const DepartmentLists = function(data) {
	return http({ url: `${base.url}/department/lists`, data, method: 'post' })
}
export const DepartmentAdd = function(data) {
	return http({ url: `${base.url}/department/add`, data, method: 'post' })
}
export const DepartmentEdit = function(data) {
	return http({ url: `${base.url}/department/edit`, data, method: 'post' })
}
export const DepartmentDel = function(data) {
	return http({ url: `${base.url}/department/del`, data, method: 'post' })
}

export const tableLists = function(data) {
	return http({ url: `${base.url}/customize/tableLists`, data, method: 'post' })
}

export const fieldLists = function(data) {
	return http({ url: `${base.url}/customize/fieldLists`, data, method: 'post' })
}

export const field = function(data) {
	return http({ url: `${base.url}/customize/field`, data, method: 'post' })
}

export const fieldDel = function(data) {
	return http({ url: `${base.url}/customize/fieldDel`, data, method: 'post' })
}

export const createtable = function(data) {
	return http({ url: `${base.url}/customize/createtable`, data, method: 'post' })
}

/////////////todo////////
export const todoLists = function(data) {
	return http({ url: `${base.url}/todo/lists`, data, method: 'post' })
}

export const todoAdd = function(data) {
	return http({ url: `${base.url}/todo/add`, data, method: 'post' })
}

export const todoEdit = function(data) {
	return http({ url: `${base.url}/todo/edit`, data, method: 'post' })
}

export const todoFinish = function(data) {
	return http({ url: `${base.url}/todo/finish`, data, method: 'post' })
}

export const todoDel = function(data) {
	return http({ url: `${base.url}/todo/del`, data, method: 'post' })
}

/////////////crm客户////////
export const batchLists = function(data) {
	return http({ url: `${base.url}/crm/batchLists`, data, method: 'post' })
}

export const batchAdd = function(data) {
	return http({ url: `${base.url}/crm/batchAdd`, data, method: 'post' })
}

export const batchEdit = function(data) {
	return http({ url: `${base.url}/crm/batchEdit`, data, method: 'post' })
}

export const batchImport = function(data) {
	return http({ url: `${base.url}/crm/batchImport`, data, method: 'post' })
}

export const batchDel = function(data) {
	return http({ url: `${base.url}/crm/batchDel`, data, method: 'post' })
}

export const parseAddress = function(data) {
	return http({ url: `${base.url}/crm/parseAddress`, data, method: 'post' })
}

export const userLists = function(data) {
	return http({ url: `${base.url}/crm/userLists`, data, method: 'post' })
}

export const userDetail = function(data) {
	return http({ url: `${base.url}/crm/userDetail`, data, method: 'post' })
}

export const unfreezeHit = function(data) {
	return http({ url: `${base.url}/crm/unfreezeHit`, data, method: 'post' })
}

export const userAdd = function(data) {
	return http({ url: `${base.url}/crm/userAdd`, data, method: 'post' })
}

export const userAddAdmin = function(data) {
	return http({ url: `${base.url}/crm/userAddAdmin`, data, method: 'post' })
}

export const userDelAdmin = function(data) {
	return http({ url: `${base.url}/crm/userDelAdmin`, data, method: 'post' })
}

export const userDel = function(data) {
	return http({ url: `${base.url}/crm/userDel`, data, method: 'post' })
}

export const userEdit = function(data) {
	return http({ url: `${base.url}/crm/userEdit`, data, method: 'post' })
}

export const userDisable = function(data) {
	return http({ url: `${base.url}/crm/userDisable`, data, method: 'post' })
}

export const userLogs = function(data) {
	return http({ url: `${base.url}/crm/userLogs`, data, method: 'post' })
}

export const applyGet = function(data) {
	return http({ url: `${base.url}/crm/applyGet`, data, method: 'post' })
}

export const applySet = function(data) {
	return http({ url: `${base.url}/crm/applySet`, data, method: 'post' })
}

export const applyLeft = function(data) {
	return http({ url: `${base.url}/crm/applyLeft`, data, method: 'post' })
}

export const applyUser = function(data) {
	return http({ url: `${base.url}/crm/applyUser`, data, method: 'post' })
}

export const applyLists = function(data) {
	return http({ url: `${base.url}/crm/applyLists`, data, method: 'post' })
}

export const applyCheck = function(data) {
	return http({ url: `${base.url}/crm/applyCheck`, data, method: 'post' })
}

export const setCrmFollowState = function(data, method = 'get') {
	return http({ url: `${base.url}/setting/setCrmFollowState`, data, method })
}

export const recycleGet = function(data) {
	return http({ url: `${base.url}/crm/recycleGet`, data, method: 'post' })
}

export const recycleSet = function(data) {
	return http({ url: `${base.url}/crm/recycleSet`, data, method: 'post' })
}

export const recycle = function(data) {
	return http({ url: `${base.url}/crm/recycle`, data, method: 'post' })
}

export const levelLists = function(data) {
	return http({ url: `${base.url}/crm/levelLists`, data, method: 'post' })
}

export const levelAdd = function(data) {
	return http({ url: `${base.url}/crm/levelAdd`, data, method: 'post' })
}

export const levelEdit = function(data) {
	return http({ url: `${base.url}/crm/levelEdit`, data, method: 'post' })
}

export const levelDel = function(data) {
	return http({ url: `${base.url}/crm/levelDel`, data, method: 'post' })
}

export const followLog = function(data) {
	return http({ url: `${base.url}/crm/followLog`, data, method: 'post' })
}

export const dispatchDepart = function(data) {
	return http({ url: `${base.url}/crm/dispatchDepart`, data, method: 'post' })
}

export const dispatchAdmin = function(data) {
	return http({ url: `${base.url}/crm/dispatchAdmin`, data, method: 'post' })
}

export const userCount = function(data) {
	return http({ url: `${base.url}/crm/userCount`, data, method: 'post' })
}

export const userFollowCount = function(data) {
	return http({ url: `${base.url}/crm/userFollowCount`, data, method: 'post' })
}

export const userFollowChart = function(data) {
	return http({ url: `${base.url}/crm/userFollowChart`, data, method: 'post' })
}

export const userFollowChartOne = function(data) {
	return http({ url: `${base.url}/crm/userFollowChartOne`, data, method: 'post' })
}

export const crmorderAdd = function(data) {
	return http({ url: `${base.url}/crm/orderAdd`, data, method: 'post' })
}

export const crmorderEdit = function(data) {
	return http({ url: `${base.url}/crm/orderEdit`, data, method: 'post' })
}

export const crmorderShipingEdit = function(data) {
	return http({ url: `${base.url}/crm/orderShipingEdit`, data, method: 'post' })
}

export const crmorderLists = function(data) {
	return http({ url: `${base.url}/crm/orderLists`, data, method: 'post' })
}
export const crmorderDetail = function(data) {
	return http({ url: `${base.url}/crm/orderDetail`, data, method: 'post' })
}

export const crmorderCancel = function(data) {
	return http({ url: `${base.url}/crm/orderCancel`, data, method: 'post' })
}

export const orderImportExpress = function(data) {
	return http({ url: `${base.url}/crm/orderImportExpress`, data, method: 'post' })
}

export const orderBatchConfirm = function(data) {
	return http({ url: `${base.url}/crm/orderBatchConfirm`, data, method: 'post' })
}

export const orderDispath = function(data) {
	return http({ url: `${base.url}/crm/orderDispath`, data, method: 'post' })
}

export const orderBatchReceive = function(data) {
	return http({ url: `${base.url}/crm/orderBatchReceive`, data, method: 'post' })
}

export const jdStatus = function(data) {
	return http({ url: `${base.url}/crm/jdStatus`, data, method: 'post' })
}

export const crmorderExport = function(data) {
	return http({ url: `${base.url}/crm/orderExport`, data, method: 'post' })
}
 
export const crmorderCheck = function(data) {
	return http({ url: `${base.url}/crm/orderCheck`, data, method: 'post' })
}

export const crmorderPay = function(data) {
	return http({ url: `${base.url}/crm/orderPay`, data, method: 'post' })
}

export const crmorderSend = function(data) {
	return http({ url: `${base.url}/crm/orderSend`, data, method: 'post' })
}

export const crmorderFollow = function(data) {
	return http({ url: `${base.url}/crm/orderFollow`, data, method: 'post' })
}

export const crmorderConfirm = function(data) {
	return http({ url: `${base.url}/crm/orderConfirm`, data, method: 'post' })
}

export const crmorderLogistics = function(data) {
	return http({ url: `${base.url}/crm/orderLogistics`, data, method: 'post' })
}

export const orderCount = function(data) {
	return http({ url: `${base.url}/crm/orderCount`, data, method: 'post' })
}

export const orderDepart = function(data) {
	return http({ url: `${base.url}/crm/orderDepart`, data, method: 'post' })
}

export const afterCount = function(data) {
	return http({ url: `${base.url}/crm/afterCount`, data, method: 'post' })
}

export const orderChart = function(data) {
	return http({ url: `${base.url}/crm/orderChart`, data, method: 'post' })
}

export const orderPerform = function(data) {
	return http({ url: `${base.url}/crm/orderPerform`, data, method: 'post' })
}

export const goodSaleCount = function(data) {
	return http({ url: `${base.url}/crm/goodSaleCount`, data, method: 'post' })
}

export const setJd = function(method, data) {
	return http({ url: `${base.url}/setting/jd`, data, method })
}

export const setKuaidi100 = function(method, data) {
	return http({ url: `${base.url}/setting/kuaidi100`, data, method })
}

export const crmorderReceive = function(data) {
	return http({ url: `${base.url}/crm/orderReceive`, data, method: 'post' })
}

export const crmcountRank = function(data) {
	return http({ url: `${base.url}/crm/countRank`, data, method: 'post' })
}

export const crmorderRank = function(data) {
	return http({ url: `${base.url}/crm/orderRank`, data, method: 'post' })
}

export const orderStateChange = function(data) {
	return http({ url: `${base.url}/crm/orderStateChange`, data, method: 'post' })
}

export const commissionLists = function(data) {
	return http({ url: `${base.url}/crm/commissionLists`, data, method: 'post' })
}

export const commissionAdd = function(data) {
	return http({ url: `${base.url}/crm/commissionAdd`, data, method: 'post' })
}

export const commissionEdit = function(data) {
	return http({ url: `${base.url}/crm/commissionEdit`, data, method: 'post' })
}

export const commissionDel = function(data) {
	return http({ url: `${base.url}/crm/commissionDel`, data, method: 'post' })
}

export const commissionCount = function(data) {
	return http({ url: `${base.url}/crm/commissionCount`, data, method: 'post' })
}

export const blacklistGet = function(data) {
	return http({ url: `${base.url}/crm/blacklistGet`, data, method: 'post' })
}

export const blacklistSet = function(data) {
	return http({ url: `${base.url}/crm/blacklistSet`, data, method: 'post' })
}

export const blacklistAdd = function(data) {
	return http({ url: `${base.url}/crm/blacklistAdd`, data, method: 'post' })
}

export const blacklistDel = function(data) {
	return http({ url: `${base.url}/crm/blacklistDel`, data, method: 'post' })
}

//////////文档/通知/短信模板////////////
export const articleLists = function(data) {
	return http({ url: `${base.url}/article/lists`, data, method: 'post' })
}

export const articleDetail = function(data) {
	return http({ url: `${base.url}/article/detail`, data, method: 'post' })
}

export const articleAdd = function(data) {
	return http({ url: `${base.url}/article/add`, data, method: 'post' })
}

export const articleEdit = function(data) {
	return http({ url: `${base.url}/article/edit`, data, method: 'post' })
}

export const articleDel = function(data) {
	return http({ url: `${base.url}/article/del`, data, method: 'post' })
}

export const articleCateLists = function(data) {
	return http({ url: `${base.url}/article/cateLists`, data, method: 'post' })
}

export const articleCateDetail = function(data) {
	return http({ url: `${base.url}/article/cateDetail`, data, method: 'post' })
}

export const articleCateAdd = function(data) {
	return http({ url: `${base.url}/article/cateAdd`, data, method: 'post' })
}

export const articleCateEdit = function(data) {
	return http({ url: `${base.url}/article/cateEdit`, data, method: 'post' })
}

export const articleCateDel = function(data) {
	return http({ url: `${base.url}/article/cateDel`, data, method: 'post' })
}

export const articleUnread = function(data) {
	return http({ url: `${base.url}/article/unread`, data, method: 'post' })
}

export const smbao = function(method, data) {
	return http({ url: `${base.url}/setting/smbao`, data, method })
}

export const getSmbaoLeft = function(data) {
	return http({ url: `${base.url}/setting/getSmbaoLeft`, data, method: 'post' })
}

export const smslogLists = function(data) {
	return http({ url: `${base.url}/article/smslogLists`, data, method: 'post' })
}

export const smslogDetail = function(data) {
	return http({ url: `${base.url}/article/smslogDetail`, data, method: 'post' })
}

export const smslogAdd = function(data) {
	return http({ url: `${base.url}/article/smslogAdd`, data, method: 'post' })
}

export const smslogEdit = function(data) {
	return http({ url: `${base.url}/article/smslogEdit`, data, method: 'post' })
}

export const smsSend = function(data) {
	return http({ url: `${base.url}/article/smsSend`, data, method: 'post' })
}

export const smslogDel = function(data) {
	return http({ url: `${base.url}/article/smslogDel`, data, method: 'post' })
}

export const smsLogCount = function(data) {
	return http({ url: `${base.url}/article/smsLogCount`, data, method: 'post' })
}